import { render, staticRenderFns } from "./UserMessageForm.vue?vue&type=template&id=72970877&scoped=true"
import script from "./UserMessageForm.vue?vue&type=script&lang=js"
export * from "./UserMessageForm.vue?vue&type=script&lang=js"
import style0 from "./UserMessageForm.vue?vue&type=style&index=0&id=72970877&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72970877",
  null
  
)

export default component.exports